import { FeedbackEndSessionDialog } from './FeedbackEndSessionDialog.jsx';
import { FeedbackReviewModal } from './FeedbackReviewModal.jsx';
import { FeedbackSessionBar } from './FeedbackSessionBar.jsx';
import { ElementSelector } from './ElementSelector.jsx';
import { RegionSelector } from './RegionSelector.jsx';
import { reviewToolsEnabled } from './reviewToolsCapability.js';

export function FeedbackMarkupOverlay() {
  if (!reviewToolsEnabled()) return null;
  return (
    <>
      <RegionSelector />
      <ElementSelector />
      <FeedbackEndSessionDialog />
      <FeedbackReviewModal />
      <FeedbackSessionBar />
    </>
  );
}
